"use strict";

var _classCallCheck = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isNode = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;

var toBuffer = require('to-buffer');

var Blaker = /*#__PURE__*/function () {
  function Blaker() {
    _classCallCheck(this, Blaker);
  }

  _createClass(Blaker, null, [{
    key: "blake2b",
    value: function blake2b(input) {
      if (isNode) {
        var avon = require('avon');

        return avon.sumBuffer(toBuffer(input), avon.ALGORITHMS.B).toString('hex');
      } else {
        var blake = require('blakejs');

        return blake.blake2bHex(input);
      }
    }
  }]);

  return Blaker;
}();
/**
 * Calculates blake2b hash
 *
 * @param input - string to be hashed
 * @returns {String} hash
 */


exports.blake2b = function (input) {
  return Blaker.blake2b(input);
};
/**
 * Calculates blake2bl hash
 *
 * @param input - string to be hashed
 * @returns {String} hash
 */


exports.blake2bl = function (input) {
  return exports.blake2b(input).slice(64, 128);
};
/**
 * Calculates blake2bl hash twice
 *
 * @param input - string to be hashed
 * @returns {String} hash
 */


exports.blake2blTwice = function (input) {
  return exports.blake2bl(exports.blake2bl(input));
};
/**
 * Calculates blake2bls hash
 *
 * @param input - string to be hashed
 * @returns {String} hash
 */


exports.blake2bls = function (input) {
  return exports.blake2b(input).slice(88, 128);
};
/**
 * Calculates blake2blc hash
 *
 * @param input - compressed address blake
 * @returns {String} hash
 */


exports.blake2blc = function (input) {
  var preimage = exports.blake2bl(input);
  var compressed = exports.blake2bls(preimage);
  return compressed;
};